import {
  BasicCarouselWidget,
  BasicCarouselWidgetProps,
} from 'consumer-page-widgets/BasicCarouselWidget';
import React from 'react';

/**
 * Displays either the "new" HorizontalScrollContainer, or the legacy carousel widget, depending on content type.
 */
const ContentTypeAwareCarouselWidget: React.FunctionComponent<BasicCarouselWidgetProps> = ({
  widget,
  listIndex,
  ...props
}) => {
  switch (widget.mode) {
    case 'legacy': {
      return <BasicCarouselWidget widget={widget} listIndex={listIndex} {...props} />;
    }

    case 'widgetBuilder': {
      return <BasicCarouselWidget widget={widget} listIndex={listIndex} {...props} />;
    }

    default:
      return null;
  }
};

export default ContentTypeAwareCarouselWidget;
